import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v5h5v11H6z"
}), 'InsertDriveFileOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/InsertDriveFileOutlined.js
// module id = 4270
// module chunks = 2